import { AppCard, AppCardContent } from '@app/components/base/app-card';
import { webApi } from '@mi-front/api-clients';
import { fragmentGridCardContentSx } from '@app/modules/fragments/screens/list/fragment-card/base/styles';
import { buildYoutubeBroadcastNavigation } from './build-youtube-broadcast-navigation';
import { YoutubeBroadcastCardMedia } from './YoutubeBroadcastCardMedia';
import { YoutubeBroadcastCardMetadata } from './YoutubeBroadcastCardMetadata';
import { YoutubeBroadcastCardTitle } from './YoutubeBroadcastCardTitle';
import { YoutubeBroadcastCardSize } from './youtube-broadcast-card-size';

export type { YoutubeBroadcastCardSize } from './youtube-broadcast-card-size';

interface YoutubeBroadcastCardProps {
  broadcast: webApi.BroadcastDto;
  stationSlug: string;
  size?: YoutubeBroadcastCardSize;
}

/**
 * Grid-style card for a YouTube broadcast: thumbnail with overlay pills, title,
 * and metadata (peak viewers + ago time). Navigates to the logger stream for the broadcast interval.
 */
export function YoutubeBroadcastCard({
  broadcast,
  stationSlug,
  size = 'large',
}: YoutubeBroadcastCardProps) {
  const to = buildYoutubeBroadcastNavigation(broadcast, stationSlug);

  return (
    <AppCard
      to={to}
      media={<YoutubeBroadcastCardMedia broadcast={broadcast} />}
      sx={{ height: '100%' }}
    >
      <AppCardContent sx={fragmentGridCardContentSx}>
        <YoutubeBroadcastCardTitle title={broadcast.video.title} size={size} />
        <YoutubeBroadcastCardMetadata broadcast={broadcast} />
      </AppCardContent>
    </AppCard>
  );
}
